import { render, staticRenderFns } from "./Random.vue?vue&type=template&id=6c64c8ca&scoped=true"
import script from "./Random.vue?vue&type=script&lang=js"
export * from "./Random.vue?vue&type=script&lang=js"
import style0 from "./Random.vue?vue&type=style&index=0&id=6c64c8ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c64c8ca",
  null
  
)

export default component.exports